import type { OrganizationUnitType } from '../models/organization.model';

/**
 * Which organization units a Dienstverhältnis may hang on.
 *
 * Customer decision of 2026-09-22: a contract belongs to a company. Never to
 * the root, which is a placeholder rather than a place, and never to a
 * department, which is an internal subdivision of one. The schema has said as
 * much since it was written — the column carries the note that the target
 * design calls it `company_id`.
 *
 * Deliberately narrower than `canHoldConfiguration`, and kept apart from it
 * rather than folded in. Configuration is maintained on the root as well
 * because everything below inherits it; a contract is inherited by nothing. It
 * is held by the legal entity that employs the person, and the root is not one.
 */
export function canHoldEmployment(type: OrganizationUnitType): boolean {
  return type === 'company';
}
